import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-daily-sale',
  templateUrl: './daily-sale.component.html',
  styleUrls: ['./daily-sale.component.scss']
})
export class DailySaleComponent implements OnInit {

  // sale_date: any = null;
  from_date: any = null;
  to_date: any = null;
  title: any;
  data_loading = false;
  is_data_available = false;
  document_file = null;
  pdf_data: any = null;

  constructor(private globalService: GlobalService, private httpService: HttpService, private domSanitizer: DomSanitizer) {
    this.title = this.globalService._active_display_name;
  }

  serveDailySale() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    this.is_data_available = false;
    this.data_loading = true;
    this.httpService.serveDailyForSelectedDate(data_dict).subscribe((data) => {
      console.log(data);
      if (data['is_data_available']) {
        this.document_file = data;
        this.pdf_data = this.domSanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
        this.is_data_available = true;
      } else {
        alert('No Data Available')
      }
      this.data_loading = false;
    }, (error) => {
      this.is_data_available = false;
      this.data_loading = false;
      console.error(error);
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    let file_name = this.document_file['file_name'];
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = file_name;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
